import React,{useEffect,useRef} from 'react';
import { Select } from 'antd';
import 'antd/dist/antd.css';
import {getTotalMarketData} from '../services/chartdata'

//按需加载
import echarts from 'echarts/lib/echarts'
//必需基础组件
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/markPoint'
//导入矩形图
import 'echarts/lib/chart/bar'　
import 'echarts/lib/chart/line'　





export default function TotalMarket(props) {
	const { Option } = Select;
	let chartDataList;

	function handleChange(value) {
		// console.log(`selected ${value}`);		
		renderChart(value-1);
	}

	const chartRef=useRef();
	const chartRef_2=useRef();
	let myChart=null;
	let myChart_2=null;
	let option = {		
		color: ['#264D73', '#84B5D5', '#19B3E8'],
		legend: {},
		tooltip:{
			show:true
		},
		title: {
			text: '广义乘用车'
		},
		grid: {
			show:false,
			left: '3%',
			right: '5%',
			width:'auto',			
		},
		xAxis: {
			type: 'category'
		},
		yAxis: [{
				type: 'value',
				splitLine:{
					show:false
				},
				name: '单位： 万辆',
				axisLabel: {
					formatter: '{value}'
				}
			},
			{
				type: 'value',
				splitLine:{
					show:false
				},
				name: '',
				axisLabel: {
					formatter: '{value} %'
				}
			}
		],
		series: [{
				type: 'bar',
				barGap: 0,
				label: {
					show: true,
					fontSize: 10,
					position: 'insideBottom',
					// position: ['50%', '50%']
					// distance:30
				}
			},
			{
				type: 'bar',
				label: {
					show: true,
					fontSize: 10,
					position: 'insideBottom'
				}
			},
			{
				type: 'line',
				yAxisIndex: 1,
				smooth: false,
				symbol: 'circle',
				symbolSize: 8,
				label: {
					show: true,
					color:'#000',
					formatter: '{@同比}%'
				}
			}
		]
	
	};

	function renderChart(numType){	

		const chart=echarts.getInstanceByDom(chartRef.current)
		if(chart){
			myChart=chart;
		}else{
			myChart=echarts.init(chartRef.current);
		}

		const chart_2=echarts.getInstanceByDom(chartRef_2.current)
		if(chart_2){
			myChart_2=chart_2;
		}else{
			myChart_2=echarts.init(chartRef_2.current);
		}

		if(chartDataList){
			renderEChart(chartDataList,myChart,0,numType);
			renderEChart(chartDataList,myChart_2,1,numType);
		}else{
		getTotalMarketData().then((dt)=>{
			chartDataList=dt;
			renderEChart(dt,myChart,0,numType);
			renderEChart(dt,myChart_2,1,numType);
		});
	}

		// renderEChart(myChart,0,numType);
		// renderEChart(myChart_2,1,numType);
	}

	function renderEChart(chartDataList,echartInstance,region,numType){
		let title='';
		if(region===0){
			title='狭义乘用车'
		}else{
			title='广义乘用车'
		}
		
		numType=numType||0;	
		

		echartInstance.setOption(option);
		
		let datalist=chartDataList[region].dataList;
		// console.log(datalist)
		let res=datalist.map(obj=>{
			let new_obj={};				
			for(let [k,v] of Object.entries(obj)){
				if(Array.isArray(v)){
					new_obj[k]=v[numType].toFixed(1);
				}else{
					new_obj[k]=v;
				}
			}
			return new_obj;
		})
		echartInstance.setOption({
			title:{'text':title},
			dataset:{
				source:res
			}
		});
		
	}

	useEffect(()=>{
		// console.log("did.....")
		renderChart();
		return ()=>{
			// console.log("unmount...");
			myChart && myChart.dispose();
		}
	})
	return (
		<>
		<div>			
			<div className={"select"}>
			<Select defaultValue="1" style={{ width: 100 }} onChange={handleChange}>
				<Option value="1">产量</Option>
				<Option value="2">批发</Option>				
				<Option value="3">零售</Option>
				<Option value="4">出口</Option>
			</Select>
			</div>
			<div style={{width: "1100px", height: "400px"}} ref={chartRef} />			
			<div style={{width: "1100px", height: "400px"}} ref={chartRef_2} />			
		</div>

		</>
	);
}
